<template>
  <div class="box-border has-background-white box-h-max h-100-per">
    <div class="mg-b-5 line-title-dh is-flex is-justify-spacebetween">
      <b-tooltip
        label="Move"
        type="is-dark"
        v-if="user.userLevel == 0"
        position="is-bottom"
      >
        <p
          class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
        >
          {{ $t("dashboard.mainDashboardPerformance") }}
        </p>
      </b-tooltip>
      <p
        v-else
        class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
      >
        {{ $t("dashboard.mainDashboardPerformance") }}
      </p>
      <p
        class="pd-y-10 icon-color is-size-5 cr-pointer"
        @click="$emit('openModalInfo', 'pfm')"
      >
        <i class="fas fa-question-circle"></i>
      </p>
    </div>
    <div class="pd-t-20 h-100-per">
      <div v-if="tasksAll.length !== 0" class="">
        <div class="is-flex is-justify-center h0">
          <div class="has-text-centered totalCompany">
            <p
              class="th is-size-3 has-text-weight-normal"
              :title="
                $t('dashboard.dashboardPerformanceTask') +
                ' ' +
                taskLeft +
                ' ' +
                $t('dashboard.ofTitle') +
                ' ' +
                tasksAll.length
              "
            >
              {{ taskPlan + taskInprocess + taskOverdue }}
            </p>
            <p class="th is-size-4 has-text-weight-normal">
              {{ $t("dashboard.dashboardPerformanceTask")
              }}{{
                taskPlan + taskInprocess + taskOverdue == 1 ||
                $i18n.locale === "th"
                  ? ""
                  : "s"
              }}
            </p>
          </div>
        </div>
        <Doughnut
          :width="220"
          :height="220"
          :labels="['Planned', 'In process', 'Overdue', 'Done']"
          :bgColor="['#6d8df3', '#ffa800', '#ac1818', '#0ecb81']"
          :numData="[taskPlan, taskInprocess, taskOverdue, taskDone]"
          :tooltipsOpen="true"
        />
        <div class="columns m-h-auto mg-y-25">
          <div class="column is-paddingless border-right-solid">
            <p
              class="is-size-2 has-text-weight-normal has-text-centered th plan-color"
            >
              {{ taskPlan }}
            </p>
            <p class="is-size-6 th has-text-centered plan-color">
              {{ $t("dashboard.dashboardStatusPlaning")
              }}{{ taskPlan == 1 || $i18n.locale === "th" ? "" : "s" }}
            </p>
          </div>
          <div class="column is-paddingless border-right-solid">
            <p
              class="is-size-2 has-text-weight-normal has-text-centered th inprocess-color"
            >
              {{ taskInprocess }}
            </p>
            <p class="is-size-6 th has-text-centered inprocess-color">
              {{ $t("dashboard.dashboardStatusInprocess")
              }}{{ taskInprocess == 1 || $i18n.locale === "th" ? "" : "s" }}
            </p>
          </div>
          <div class="column is-paddingless border-right-solid">
            <p
              class="is-size-2 has-text-weight-normal has-text-centered th overdue-color"
            >
              {{ taskOverdue }}
            </p>
            <p class="is-size-6 th has-text-centered overdue-color">
              {{ $t("dashboard.dashboardStatusOverdue")
              }}{{ taskOverdue == 1 || $i18n.locale === "th" ? "" : "s" }}
            </p>
          </div>
          <div class="column is-paddingless">
            <p
              class="is-size-2 has-text-weight-normal has-text-centered th done-color"
            >
              {{ taskDone }}
            </p>
            <p class="is-size-6 th has-text-centered done-color">
              {{ $t("dashboard.dashboardStatusDone")
              }}{{ taskDone == 1 || $i18n.locale === "th" ? "" : "s" }}
            </p>
          </div>
        </div>
        <div class="columns m-h-auto pd-20">
          <div class="column is-6 is-flex is-justify-center has-text-centered">
            <div
              class="box-task-work view-detail"
              @click="$emit('openIsDetailWorkToday')"
            >
              <p class="is-size-6 th has-text-weight-normal th">
                {{ $t("dashboard.startedTaskDetailsHeader") }}
              </p>
              <p
                class="th"
                v-if="
                  taskDoingToday.length > 0 || taskDoingTodayFuture.length > 0
                "
              >
                {{ $t("message.viewData") }}
              </p>
            </div>
          </div>
          <div class="column is-6 is-flex is-justify-center has-text-centered">
            <div
              class="box-task-work view-detail"
              @click="$emit('openIsDetailWorkTodaySuccess')"
            >
              <p class="has-text-weight-normal is-size-6 th">
                {{ $t("dashboard.dashboardDoneTaskButton") }}
              </p>
              <p
                class="th"
                v-if="
                  taskDoingTodaySuccess.length > 0 ||
                  taskDoingPastSuccess.length > 0
                "
              >
                {{ $t("message.viewData") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center h-100-per"
      >
        <p>*** {{ $t("dashboard.notfound") }} ***</p>
      </div>
    </div>
  </div>
</template>

<script>
import Doughnut from "@/charts/Doughnut";
export default {
  components: {
    Doughnut,
  },
  props: ["useBy", "tasksAllStartup"],
  computed: {
    getRule() {
      return this.$store.getters.getRule;
    },
    user() {
      return this.$store.state.user;
    },
    taskLeft() {
      return this.taskPlan + this.taskInprocess + this.taskOverdue;
    },
    tasksAll() {
      if (this.useBy === "startup") {
        let filter = this.$store.getters.tasks.filter(
          (item) => item.fundStatus !== 4
        );
        return filter;
      } else {
        let task =
          typeof this.tasksAllStartup !== "undefined"
            ? this.tasksAllStartup
            : [];
        let filter = task.filter((item) => item.fundStatus !== 4);
        return filter;
      }
    },
    taskInprocess() {
      let filter = this.tasksAll.filter(
        (item) => item.status === 2 && item.fundStatus != 4
      );
      return filter.length;
    },
    taskPlan() {
      let filter = this.tasksAll.filter(
        (item) => item.status === 1 && item.fundStatus != 4
      );
      return filter.length;
    },
    taskDone() {
      let filter = this.tasksAll.filter(
        (item) =>
          item.finishProcessDate !== "" &&
          item.finishProcessDate !== null &&
          typeof item.finishProcessDate !== "undefined" &&
          item.fundStatus != 4
      );
      return filter.length;
    },
    taskOverdue() {
      let filter = this.tasksAll.filter(
        (item) =>
          item.status === 4 &&
          (item.finishProcessDate === "" ||
            item.finishProcessDate === null ||
            typeof item.finishProcessDate === "undefined") &&
          item.fundStatus != 4
      );
      return filter.length;
    },
    taskDoingToday() {
      let filter = this.tasksAll.filter(
        (item) =>
          new Date(item.startDate).toLocaleDateString() ===
          new Date().toLocaleDateString()
      );
      return filter;
    },
    taskDoingTodayFuture() {
      let now = new Date().setHours(0, 0, 0, 0);
      let future = new Date().setHours(0, 0, 0, 0) + 86400000 * 7;
      let filter = this.tasksAll.filter(
        (item) =>
          new Date(item.startDate).getTime() > new Date(now).getTime() &&
          new Date(item.startDate).getTime() <= new Date(future).getTime()
      );
      return filter;
    },
    taskDoingTodaySuccess() {
      let filter = this.tasksAll.filter(
        (item) =>
          new Date(item.endDate).toLocaleDateString() ===
          new Date().toLocaleDateString()
      );
      return filter;
    },
    taskDoingPastSuccess() {
      let filter = this.tasksAll.filter(
        (item) =>
          new Date().setHours(0, 0, 0, 0) > new Date(item.endDate).getTime() &&
          item.fundStatus !== 5
      );
      return filter;
    },
  },
  data() {
    return {
      isDetailWorkToday: false,
      isDetailWorkTodaySuccess: false,
    };
  },
  methods: {
    modalActive(status) {
      this.$store.commit("setModalActive", status);
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .border-right-solid {
    border-right-style: outset;
    border-width: 0px;
    border-color: #d8d8d8;
  }
  .flex-compamyName {
    display: flex;
    margin: 1rem 0;
  }
}
@media screen and (min-width: 769px) {
  .border-right-solid {
    border-right-style: solid;
    border-width: 1.5px;
    border-color: #d8d8d8;
  }
}
@media screen and (min-width: 1281px) {
}
.totalCompany {
  position: relative;
  top: 65px;
  line-height: 35px;
}
.h0 {
  height: 0 !important;
}
</style>